module.exports = function(data) {
var __t, __p = '';
__p += '<div class="filter-icon">\n   <span class="fa-layers fa-fw" aria-hidden="true">\n      <i class="far fa-filter filter-menu-icon"></i>\n      <i class="fas fa-chevron-down chevron-menu-icon" data-fa-transform="shrink-10 right-10"></i>\n   </span>\n</div>\n<div class="tokens">\n    <input type="text" id="' +
((__t = ( data.cid )) == null ? '' : __t) +
'" placeholder="' +
((__t = ( data.placeholder )) == null ? '' : __t) +
'" class="typeahead">\n    <button class="add btn btn-default" disabled="disabled">Add</button>\n</div>\n\n';
return __p
}